import { t } from '@lingui/core/macro';
import { dateOfBirthRegex, numericRegex } from 'noddi-util';
import { z } from 'zod';

const checkLeapYear = (value: string | undefined) => {
  const parts = value?.split(/[-/.]/);
  if (parts && parts.length === 3) {
    const day = parseInt(parts[0] ?? '', 10);
    const month = parseInt(parts[1] ?? '', 10);
    const year = parseInt(parts[2] ?? '', 10);

    if (month === 2) {
      if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        return day <= 29;
      }
      return day <= 28;
    }
    return true;
  }
  return false;
};

/** Full form shape; the two submit-mode validators below narrow one field each. */
export const nafMembershipFormSchema = z.object({
  membershipNumber: z.number().nullable(),
  dateOfBirth: z.string()
});

export const getMembershipNumberValidationSchema = () =>
  nafMembershipFormSchema.extend({
    membershipNumber: z
      .number({ error: t`Membership number is required` })
      .refine((v) => numericRegex.test(String(v)), { message: t`Membership number can only contain numbers` })
      // Backend rejects anything outside 6-8 digits (NAFMembershipAddInput).
      .refine((v) => String(v).length >= 6 && String(v).length <= 8, { message: t`Must be 6 to 8 digits` })
  });

export const getDateOfBirthValidationSchema = () =>
  nafMembershipFormSchema.extend({
    dateOfBirth: z
      .string()
      .min(1, t`Date of birth is required`)
      .regex(dateOfBirthRegex, t`Date of birth must be in the format DD.MM.YYYY`)
      .refine(checkLeapYear, { message: t`Date of birth is not valid` })
  });
